const downloadAttachmentByUrl = async (url: string, filename: string): Promise<void> => {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to download attachment: ${response.status}`);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  link.rel = 'noreferrer';
  document.body.append(link);
  link.click();
  link.remove();

  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
};

export { downloadAttachmentByUrl };
